var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckIconWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9072 0.779647C10.7699 0.646297 10.5829 0.571289 10.3879 0.571289C10.1929 0.571289 10.0059 0.646297 9.8686 0.779647L4.41966 6.0344L2.13037 3.82262C1.93904 3.64017 1.66061 3.57092 1.40148 3.64133C1.14234 3.71174 0.942549 3.91093 0.878446 4.16278C0.814343 4.41463 0.895835 4.68023 1.09178 4.85807L3.90036 7.56293C4.0377 7.69628 4.22464 7.77129 4.41966 7.77129C4.61468 7.77129 4.80162 7.69628 4.93895 7.56293L10.9072 1.8151C11.0573 1.68175 11.1426 1.49404 11.1426 1.29737C11.1426 1.10071 11.0573 0.912999 10.9072 0.779647Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIconWhite);
export default __webpack_public_path__ + "static/media/check-icon-white.73d039b3db2f89db968104f8ba3f3e44.svg";
export { ForwardRef as ReactComponent };